import ProviderSettings from "./ProviderSettings"

export default ProviderSettings
